import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { MeetingStatisticsDTO, ProblemMeetingDTO} from '../dto/MeetingStatisticsDTOs';
import { genNoobookHeader } from './Common';
import { ReportedBookcommunityDTO, BookcommunityInfoDTO } from '../dto/BookcommunityDTOs';

/**
 * 모임 통계 데이터 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD)
 * @param endDate 종료일 (YYYY-MM-DD)
 */
export function getMeetingStatistics(
  authToken: string,
  startDate?: string,
  endDate?: string
): Promise<ResponseDTO<MeetingStatisticsDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  
  return ApiComm.getData<ResponseDTO<ReportedBookcommunityDTO[]>> (
    '/close/v1/admin/bookcommunity/reported/bookcommunities' //, {page: page, size: size}, genNoobookHeader(authToken, null, 'application/json', 'app')).then(resp => resp.data);
    , {page:0, size:10}
    , genNoobookHeader(authToken, null, 'application/json', "admin_web"))
    .then(resp => resp.data)
    .then((reportedBookcommunities) => {     
      //alert(JSON.stringify(problemMeetings));
      const problemMeetings = reportedBookcommunities?.response?.map((bookcommunity: ReportedBookcommunityDTO) => {
        return {
          bookcommunityId: bookcommunity.bookcommunityId,
          meetingName: bookcommunity.title,
          reportCount: bookcommunity.reportCount,
        };
      });

      return ApiComm.getData<ResponseDTO<BookcommunityInfoDTO[]>>(`/close/v1/bookcommunity/hashtag/bookcommunities`
        , {page:0, size:10, sort:["total_count,desc","bc.created_at,desc"]}
        , genNoobookHeader(authToken, null, 'application/json', "admin_web")
    ).then(resp=>resp.data)
     .then(popularBookcommunities=>{
      let rank = 1;
      const topMeetingsByParticipation = popularBookcommunities?.response?.map((bookcommunity: BookcommunityInfoDTO) => {
        return {
          rank: rank++,
          meetingName: bookcommunity.title,
          textCount: bookcommunity.textCount,
          bookCount: bookcommunity.bookCount,
          participationRate: 0,
        };
      });
       const mockData: MeetingStatisticsDTO = {
         activeMeetingSummary: {
           total: 150,
           inProgress: 120,
           nearingCompletion: 30,
         },
         newMeeting: {
           count: 15,
           trend: 'up',
         },
         topMeetingsByParticipation: topMeetingsByParticipation,
         problemMeetings: problemMeetings,
       };

       const response: ResponseDTO<MeetingStatisticsDTO> = {
         errorCode: 0,
         response: mockData,
         page: {
           current: 1,
           last: 1,
           total: 1,
         },
       };
       return response;
     });
     
    });

}

